module.exports = "<a class=\"images-text text-anexar-image\">\n    <img class=\"icon-add-image\" [src]=\"changeIconAnexar()\"> {{ changeButtonAnexarName() }}\n</a>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/anexar-imagens-label/anexar-imagens-label.component.html
// module id = ./src/app/components/anexar-imagens-label/anexar-imagens-label.component.html
// module chunks = main